import { cn as e } from "../cn.js";
import { descriptionListCardInnerStyles as t, descriptionListCardStyles as n, descriptionListDetailsStyles as r, descriptionListRootStyles as i, descriptionListRowStyles as a, descriptionListSectionContentStyles as o, descriptionListSectionStyles as s, descriptionListSectionTitleStyles as c, descriptionListTermStyles as l, getDescriptionListStyles as u } from "./style.js";
import { ApprovalDetails as d, DescriptionListPresets as f, LeaveRequestDetails as p, LevelList as m } from "./presets.js";
import * as h from "react";
import { jsx as g, jsxs as _ } from "react/jsx-runtime";
// src/design/description-list/index.tsx
var v = (e) => h.Children.toArray(e).some((e) => h.isValidElement(e) && (e.type === b || e.type === w)), y = h.forwardRef(({ className: t, children: n, ...r }, a) => {
	let o = e(i(), t);
	return v(n) ? /* @__PURE__ */ g("div", {
		ref: a,
		className: o,
		...r,
		children: n
	}) : /* @__PURE__ */ g("dl", {
		ref: a,
		className: o,
		...r,
		children: n
	});
});
y.displayName = "DescriptionList.Root";
var b = h.forwardRef(({ className: r, variant: i = "divider", bordered: a = !0, flush: o = !1, color: s = "none", children: c, ...l }, u) => /* @__PURE__ */ g("div", {
	ref: u,
	className: e(n({
		variant: i,
		bordered: a,
		flush: o,
		color: s
	}), r),
	...l,
	children: v(c) ? /* @__PURE__ */ g("div", {
		className: e(t({ variant: i })),
		children: c
	}) : /* @__PURE__ */ g("dl", {
		className: e(t({ variant: i })),
		children: c
	})
}));
b.displayName = "DescriptionList.Card";
var x = h.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("div", {
	ref: r,
	className: e(a(), t),
	...n
}));
x.displayName = "DescriptionList.Row";
var S = h.forwardRef(({ className: t, size: n = "md", ...r }, i) => /* @__PURE__ */ g("dt", {
	ref: i,
	className: e(l({ size: n }), t),
	...r
}));
S.displayName = "DescriptionList.Term";
var C = h.forwardRef(({ className: t, size: n = "md", muted: i = !1, ...a }, o) => /* @__PURE__ */ g("dd", {
	ref: o,
	className: e(r({
		size: n,
		muted: i
	}), t),
	...a
}));
C.displayName = "DescriptionList.Details";
var w = h.forwardRef(({ className: t, title: n, children: r, ...i }, a) => /* @__PURE__ */ _("div", {
	ref: a,
	className: e(s(), t),
	...i,
	children: [n && /* @__PURE__ */ g("h3", {
		className: c(),
		children: n
	}), /* @__PURE__ */ g("dl", {
		className: n ? o() : "",
		children: r
	})]
}));
w.displayName = "DescriptionList.Section";
var T = h.forwardRef(({ variant: e = "divider", items: t, compact: n = !1, className: r, cardColor: i = "none", cardBordered: a = !0, flush: o = !1, ...s }, c) => /* @__PURE__ */ g(y, {
	ref: c,
	className: r,
	...s,
	children: /* @__PURE__ */ g(b, {
		variant: e,
		bordered: a,
		color: i,
		flush: o,
		children: t.map((e, t) => /* @__PURE__ */ _(x, { children: [/* @__PURE__ */ g(S, {
			size: n ? "sm" : "md",
			children: e.label
		}), /* @__PURE__ */ g(C, {
			size: n ? "sm" : "md",
			muted: e.muted,
			children: e.value
		})] }, t))
	})
}));
T.displayName = "DefaultDescriptionList";
var E = Object.assign(T, {
	Root: y,
	Card: b,
	Row: x,
	Term: S,
	Details: C,
	Section: w,
	getStyles: u
});
export { d as ApprovalDetails, E as DescriptionList, f as DescriptionListPresets, p as LeaveRequestDetails, m as LevelList };

//# sourceMappingURL=index.js.map